import {createSelector} from "reselect";
import {RootState} from "../../../types";
import {Post} from "../../../../../vkapi/objects/Post";

const select_items = (state: RootState) => state.popularPosts.result;

const selectFiltered = createSelector([select_items], (items: Post[]) => {
    return items;
});

export default selectFiltered;
